import { useMemo } from "react";
import { Provider } from "react-redux";
import Personal from "./Personal";

const PersonalApp = () => {
  const store = useMemo(() => ReactOnRails.getStore("layoutStore"), []);
  return (
    <Provider store={store}>
      <Personal />
    </Provider>
  );
};

export default PersonalApp;
